import { $$ } from 'utils/dom';
import LoadMore from 'modules/load-more';

const listTeasers = $$('.list-teaser[data-ajax]');
listTeasers.length &&
  listTeasers.forEach(teaser => {
    teaser &&
      new LoadMore({
        container: teaser,
      }).init();
  });
